import PaymentDashboard from './PaymentDashboard';

export default PaymentDashboard;
